import { Form } from 'vform';
import { getHttp } from '@/api/httpFactory';

Form.axios = getHttp(import.meta.env.VITE_API_BASE_URL);

/**
 * Function to switch the axios instance
 * @param {string} baseUrl URL base to set a new axios instance
 */
export function setAxiosInstance(baseUrl) {
    Form.axios = getHttp(baseUrl ?? import.meta.env.VITE_API_BASE_URL);
}

/**
 * Function to temporarily use a different Axios instance
 * @param {string} baseUrl URL base to set a new temporary axios instance
 * @param {Form} formInstance (optional) A custom instance of the Form
 * @param {*} callback Function/Method to use the Form.axios temp instance
 */
export async function useTempAxiosInstance(baseUrl, formInstance, callback) {
    const originalAxios = Form.axios;

    try {
        Form.axios = getHttp(baseUrl);

        return await callback(formInstance);
    } finally {
        Form.axios = originalAxios;
    }
}

export { Form };
